module.exports = __webpack_public_path__ + "img/preorder.3a0d8e0.svg";